module.exports = __webpack_public_path__ + "static/img/sm_living.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm_living.jpg
// module id = zN42
// module chunks = 0